import React, { useState } from "react";
// 🎯 FIXED PATH: Reaching the view in the sibling folder
import TemplateHeaderView from "../views/TemplateHeaderView";

export default function TemplateHeaderController({ sourceFile, onHeaderGenerated, onBack }) {
  const [formData, setFormData] = useState({
    name: "",
    createdBy: sessionStorage.getItem("SEC_USER_NAME") || "Logged In User",
    createdOn: new Date().toLocaleDateString(),
    comments: "",
    status: "Draft",
    version: "1"
  });

  const [isProvisioning, setIsProvisioning] = useState(false);

  const handleGenerateHeader = async () => {
    setIsProvisioning(true);
    const templateFolder = sourceFile.filename.replace(/\.[^/.]+$/, "");

    const infraPayload = {
      bucket: "esg_templates",
      siteKey: process.env.REACT_APP_SITE_KEY,
      templateFolder: templateFolder,
      details: formData
    };

    try {
      console.log("🛠️ Invoking S3_Core Infrastructure Provisioning...", infraPayload);
      // Simulate successful handshake
      onHeaderGenerated({ ...formData, templateFolder });
    } catch (err) {
      alert("Infrastructure Error: " + err.message);
    } finally {
      setIsProvisioning(false);
    }
  };

  return (
    <TemplateHeaderView 
      data={formData}
      isProcessing={isProvisioning}
      onUpdate={(field, val) => setFormData({...formData, [field]: val})}
      onGenerate={handleGenerateHeader}
      onBack={onBack}
    />
  );
}